module.exports = __webpack_public_path__ + "static/media/12-1.3d5f7a28.svg";